import { lazy, Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import AuthCallback from "@/components/AuthCallback";

const Player = lazy(() => import("@/pages/Player"));
const Login = lazy(() => import("@/pages/Login"));
const Admin = lazy(() => import("@/pages/Admin"));
const Credits = lazy(() => import("@/pages/Credits"));

const TOASTER_STYLE = {
  background: "#0A0A0A",
  border: "1px solid #27272A",
  color: "#F3F3F2",
  borderRadius: 0,
  fontFamily: "Manrope, sans-serif",
};

const TOASTER_OPTIONS = { style: TOASTER_STYLE };

const RouteFallback = () => (
  <div className="min-h-screen flex items-center justify-center text-[#A1A1AA] font-body text-xs tracking-[0.2em] uppercase">
    Loading…
  </div>
);

// Detect the `#session_id=…` fragment synchronously (before any other route renders)
// so the OAuth callback always processes first. REMINDER: DO NOT HARDCODE THE URL
// OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/watch" element={<Player />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/credits" element={<Credits />} />
      </Routes>
    </Suspense>
  );
}

function App() {
  // Global content-protection: disable right-click and common devtools /
  // view-source keyboard shortcuts across every page of the app.
  useEffect(() => {
    const onContext = (e) => e.preventDefault();
    const onKey = (e) => {
      if (e.key === "F12") return e.preventDefault();
      const k = e.key?.toLowerCase();
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && ["i", "j", "c"].includes(k))
        return e.preventDefault();
      if ((e.ctrlKey || e.metaKey) && k === "u") return e.preventDefault();
      if ((e.ctrlKey || e.metaKey) && k === "s") return e.preventDefault();
    };
    document.addEventListener("contextmenu", onContext);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("contextmenu", onContext);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={TOASTER_OPTIONS} />
    </div>
  );
}

export default App;
